export const DEFAULT_CONTROL_VARIANT = 'control';
export const FF_PREFIX = 'exp_';

// Each experiment gets its own { KEY, VARIANTS } namespace instead of bare strings, so
// call sites use a typed constant instead of a raw string. Namespacing variants per
// experiment avoids collisions (e.g. web_tn_upsell_1 and web_tn_exp_1 share "variant1").

export const WEB_COLD_START_PRESELECT = {
    KEY: 'web_cold_start_preselect_title_from_acquisition_campaign',
    VARIANTS: {
        PRESELECT: 'preselect',
    },
} as const;

export const WEB_CANCEL_CTAS_WHITE = {
    KEY: 'web_cancel_ctas_white',
    VARIANTS: {
        CTAS_WHITE: 'ctas_white',
    },
} as const;

export const WEB_HERO_SHOW_WALL_OCT2026 = {
    KEY: 'web_hero_show_wall_oct2026',
    VARIANTS: {
        DRAMA_REALITY: 'drama_reality',
        URBAN_DRAMA: 'urban_drama',
        WESTERN_DRAMA: 'western_drama',
        ORIGINALS_DRAMA: 'originals_drama',
        CRIME_THRILLS: 'crime_thrills',
        BROAD_MIX: 'broad_mix',
        ALL_AUDIENCE: 'all_audience',
    },
} as const;

export const WEB_TN_UPSELL_2 = {
    KEY: 'web_tn_upsell_2',
    VARIANTS: {
        VARIANT_2: 'variant2',
    },
} as const;

// App-wide health check via AbFrameworkHealthCheck (ptv-appshell); also on
// ABTestsVariantsApi's API_VARIANTS_FILTER allowlist.
export const GENERIC_INTEGRATION_ONE = {
    KEY: 'generic_integration_one',
    VARIANTS: {
        TEST_ON: 'test_on',
    },
} as const;

// Manual dev-drawer verification keys carried over from experiments.jsonc's "TEST CASES"
// section, trimmed to key + variants now that StatSig owns targeting.
export const WEB_TN_UPSELL_1 = {
    KEY: 'web_tn_upsell_1',
    VARIANTS: {
        VARIANT_1: 'variant1',
    },
} as const;

export const WEB_TN_UPSELL_3 = {
    KEY: 'web_tn_upsell_3',
    VARIANTS: {
        VARIANT_3: 'variant3',
    },
} as const;

export const WEB_TN_UPSELL_OFF = {
    KEY: 'web_tn_upsell_off',
    VARIANTS: {
        OPTIMIZELY_NOT_ENABLED: 'optimizely_not_enabled',
    },
} as const;

export const WEB_TN_EXP_1 = {
    KEY: 'web_tn_exp_1',
    VARIANTS: {
        VARIANT_1: 'variant1',
    },
} as const;

export const WEB_TN_EXP_2 = {
    KEY: 'web_tn_exp_2',
    VARIANTS: {
        VARIANT_2: 'variant2',
    },
} as const;

// Object.values() on an `as const` VARIANTS object infers a literal-tuple type (e.g.
// ["variant2"]) rather than string[], which then rejects `.includes(DEFAULT_CONTROL_VARIANT)`
// downstream — widen explicitly so every entry is a normal string[].
const variantsOf = (variants: Record<string, string>): string[] => Object.values(variants);

// The registry itself is just an aggregation of the constants above — useExperiment's
// only job is to look up { variants } by key.
export const EXPERIMENTS = {
    [WEB_COLD_START_PRESELECT.KEY]: { variants: variantsOf(WEB_COLD_START_PRESELECT.VARIANTS) },
    [WEB_CANCEL_CTAS_WHITE.KEY]: { variants: variantsOf(WEB_CANCEL_CTAS_WHITE.VARIANTS) },
    [WEB_HERO_SHOW_WALL_OCT2026.KEY]: { variants: variantsOf(WEB_HERO_SHOW_WALL_OCT2026.VARIANTS) },
    [WEB_TN_UPSELL_2.KEY]: { variants: variantsOf(WEB_TN_UPSELL_2.VARIANTS) },
    [GENERIC_INTEGRATION_ONE.KEY]: { variants: variantsOf(GENERIC_INTEGRATION_ONE.VARIANTS) },
    [WEB_TN_UPSELL_1.KEY]: { variants: variantsOf(WEB_TN_UPSELL_1.VARIANTS) },
    [WEB_TN_UPSELL_3.KEY]: { variants: variantsOf(WEB_TN_UPSELL_3.VARIANTS) },
    [WEB_TN_UPSELL_OFF.KEY]: { variants: variantsOf(WEB_TN_UPSELL_OFF.VARIANTS) },
    [WEB_TN_EXP_1.KEY]: { variants: variantsOf(WEB_TN_EXP_1.VARIANTS) },
    [WEB_TN_EXP_2.KEY]: { variants: variantsOf(WEB_TN_EXP_2.VARIANTS) },
} as const;
